import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";

import { CommonModule } from "@angular/common";
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { MatNativeDateModule, MatOptionModule, MatRippleModule } from "@angular/material/core";
import { FuseWidgetModule } from "@fuse/components/widget/widget.module";
import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgChartsModule } from "ng2-charts";
import { CurrencyMaskModule } from "ng2-currency-mask";
import { provideNgxMask } from "ngx-mask";
import { MatBadgeModule } from "@angular/material/badge";

//Modules
import { ClientesModule } from "app/clientes/clientes.module";
import { BaseModule } from "../base-module/base.module";
import { ListaAtividadesRoutesModule } from "./lista-atividades.routing";

//Componentes
import { CadastraAtividadeClientesComponent } from "./cadastra-atividade-clientes/cadastra-atividade-clientes.component";
import { CadastroAssuntoComponent } from "./cadastro-assunto/cadastro-assunto.component";
import { FiltroAtividadesComponent } from "./filtro-atividades/filtro-atividades.component";
import { ListaAssuntoComponent } from "./lista-assunto/lista-assunto.component";
import { ListaTodasAtividadesComponent } from "./lista-todas-atividades/lista-todas-atividades.component";
import { ModalShowAtividadeComponent } from "./modal-show-atividade/modal-show-atividade.component";
import { ResponderAtividadeComponent } from "./responder-atividade/responder-atividade.component";
import { RespostaAtividadeComponent } from "./resposta-atividade/resposta-atividade.component";
import { RespostaTarefaEspecialistaComponent } from "./resposta-tarefa-especialista/resposta-tarefa-especialista.component";

//Services
import { ModalEscolhaAcaoComponent } from "./modal-escolha-acao/modal-escolha-acao.component";
import { ListaAtividadeAssuntoService } from "./services/lista-atividade-assunto.service";
import { ListaAtividadeClienteService } from "./services/lista-atividade-clientes.service";
import { TarefasRespostaUsuarioEspecialista } from "./services/lista-atividades-tarefa-resposta-especialista.service";
import { ListaAtividadeService } from "./services/lista-atividades.service";
import { UploadTarefasArquivosComponent } from "./upload-tarefas-arquivos/upload-tarefas-arquivos.component";
import { TarefaArquivosService } from "./services/tarefa-arquivos.service";
import { MatIconModule } from "@angular/material/icon";
import { MatCardModule } from "@angular/material/card";
import { MatInputModule } from "@angular/material/input";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatButtonModule } from "@angular/material/button";
import { MatGridListModule } from "@angular/material/grid-list";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatSnackBarModule } from "@angular/material/snack-bar";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatListModule } from "@angular/material/list";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatTabsModule } from "@angular/material/tabs";
import { MatRadioModule } from "@angular/material/radio";
import { MatMenuModule } from "@angular/material/menu";
import { MatChipsModule } from "@angular/material/chips";
import { MatExpansionModule } from "@angular/material/expansion";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSortModule } from "@angular/material/sort";
import { MatTableModule } from "@angular/material/table";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatButtonToggleModule } from "@angular/material/button-toggle";

@NgModule({
    schemas:[CUSTOM_ELEMENTS_SCHEMA],
    imports: [
        CommonModule,        
        ListaAtividadesRoutesModule,
        MatIconModule,
        MatCardModule,
        MatInputModule,
        MatCheckboxModule,
        MatButtonModule,
        MatGridListModule,
        MatToolbarModule,
        MatProgressSpinnerModule,
        MatTooltipModule,
        MatButtonToggleModule,
        MatSnackBarModule,
        MatPaginatorModule,
        MatListModule,
        MatSelectModule,
        MatOptionModule,
        MatAutocompleteModule,
        MatDatepickerModule,
        MatTabsModule,
        MatRadioModule, 
        MatMenuModule, 
        MatChipsModule, 
        MatExpansionModule, 
        MatFormFieldModule, 
        MatRippleModule, 
        MatSortModule, 
        MatTableModule,
        FormsModule,
        MatSlideToggleModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        BaseModule,
        MatNativeDateModule,
        CurrencyMaskModule,
        ClientesModule,
        FuseWidgetModule,
        NgxChartsModule,
        NgChartsModule,
        MatBadgeModule
    ],
    declarations: [
        CadastroAssuntoComponent,
        ListaAssuntoComponent,
        CadastraAtividadeClientesComponent,
        ModalShowAtividadeComponent,
        ListaTodasAtividadesComponent,
        FiltroAtividadesComponent,
        RespostaAtividadeComponent,
        RespostaTarefaEspecialistaComponent,
        ResponderAtividadeComponent,
        ModalEscolhaAcaoComponent,
        UploadTarefasArquivosComponent
    ],
    providers: [
       ListaAtividadeAssuntoService,
       ListaAtividadeService,
       ListaAtividadeClienteService,
       TarefasRespostaUsuarioEspecialista,
       TarefaArquivosService,
       provideNgxMask()
    ]
})
export class ListaAtividadesModule { }
